import React from 'react'

const CounsellingHomeHeaderSkeleton = () => {
    return (
        <div className="well-tracker-header flex items-center animate-pulse">
            <div className="h-8 w-[220px] bg-lightBG rounded opacity-50"></div>
            <div style={{ flex: 1 }}></div>
            <div className="well-search-container flex items-center"></div>
            <div className="rounded-full bg-lightBG h-[55px] w-[55px]">
                <div className="h-10 w-10 bg-lightBG rounded-full opacity-50"></div>
            </div>
        </div>
    )
}

export default CounsellingHomeHeaderSkeleton
